import { render, staticRenderFns } from "./Bracket32.vue?vue&type=template&id=67470877&"
import script from "./Bracket32.vue?vue&type=script&lang=js&"
export * from "./Bracket32.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports